export default __webpack_public_path__ + "static/media/business-info-1x.954202f7.png";